<template>
    <div class="vipbody">
        <div class="banner">
            <img src="@/assets/img/vipbanner.jpg" alt="" />
        </div>
        <div class="box1 box flex" v-loading="loading">
            <div class="item">
                <div class="item-t item-t1">
                    <div class="txt">
                        <p class="h2">个人会员</p>
                        <p class="h3">海量数据查阅</p>
                        <p class="h3">企业动态更新</p>
                    </div>
                </div>
                <div class="item-b item-b1">
                    <div class="select flex">
                        <div class="option" v-for="(item,index) in priceList" :key='index' :class="{ xz: option1Show == index }" @click="select(index)">
                            <p class="h2">
                                <span>{{ Number(item.price).toFixed(2) }}</span>元/{{item.month==1?'月':item.month==6?'半年':'年'}}
                            </p>
                            <p class="h3">
                                <span>{{ parseFloat(item.price / (item.month)).toFixed(2) }}</span>元/月
                            </p>
                        </div>
                        <!-- <div class="option" :class="{ xz: option1Show == 1 }" @click="select(1, 1)">
                        <p class="h2">
                            <span>{{ Number(priceList[1].price).toFixed(2) }}</span>元/半年
                        </p>
                    </div>
                    <div class="option" :class="{ xz: option1Show == 2 }" @click="select(2, 2)">
                        <p class="h2">
                            <span>{{ Number(priceList[2].price).toFixed(2) }}</span>元/年
                        </p>
                    </div> -->
                    </div>
                    <a href="javascript:;" class="kt" @click="openvip(1)">立即开通</a>
                </div>
            </div>

        </div>
        <div class="box2">
            <div class="tit">
                <img src="@/assets/img/vip/left.png" alt="" />
                <p>会员尊享特权</p>
                <img src="@/assets/img/vip/right.png" alt="" />
            </div>
            <div class="form flex">
                <div class="item item1">
                    <div class="item-t center">
                        <p>享受权益</p>
                    </div>
                    <div class="quanyi bgf1">
                        <div class="txt">
                            <div class="h2">
                                <img src="@/assets/img/vip/none.png" alt="" />
                                <p>海量数据</p>
                            </div>
                            <p class="h3">海量企业数据任您查询筛选</p>
                        </div>
                    </div>
                    <div class="quanyi">
                        <div class="txt">
                            <div class="h2">
                                <img src="@/assets/img/vip/ntwo.png" alt="" />
                                <p>企业动态随时查询</p>
                            </div>
                            <p class="h3">关注企业信息，动态更新及时提醒</p>
                        </div>
                    </div>
                    <div class="quanyi bgf1">
                        <div class="txt">
                            <div class="h2">
                                <img src="@/assets/img/vip/nthree.png" alt="" />
                                <p>主账号管理</p>
                            </div>
                            <p class="h3">主账号可修改子账号，解决人员变动问题</p>
                        </div>
                    </div>
                    <div class="quanyi quany4">
                        <div class="txt">
                            <div class="h2">
                                <img src="@/assets/img/vip/nfour.png" alt="" />
                                <p>多人更实惠</p>
                            </div>
                            <p class="h3">5人起购，套餐价格更实惠</p>
                        </div>
                    </div>
                </div>
                <div class="item item2" :class="{ fd1: tq == 0 }">
                    <div class="center top-c top-c1">
                        <div class="vip">
                            <img v-if="this.tq == 0" src="@/assets/img/vip/ywguan.png" alt="" />
                            <img v-if="this.tq == 1" src="@/assets/img/vip/yellguan.png" alt="" />
                            <p>个人会员</p>
                        </div>
                        <a class="ktvip ktvip1" href="javascript:;" @click="openvip(1)">开通会员</a>
                    </div>
                    <div class="border-lr quanyi center bgf1">
                        <img src="@/assets/img/vip/dui.png" alt="" />
                    </div>
                    <div class="border-lr quanyi center">
                        <img src="@/assets/img/vip/dui.png" alt="" />
                    </div>
                    <div class="border-lr quanyi center bgf1">
                        <img src="@/assets/img/vip/cuo.png" alt="" />
                    </div>
                    <div class="border-lr quanyi center border-b">
                        <img src="@/assets/img/vip/cuo.png" alt="" />
                    </div>
                </div>

                <div class="item item4">
                    <div class="item-top center border-l">
                        <img src="@/assets/img/vip/grayguan.png" alt="" />
                        <p>普通用户</p>
                    </div>
                    <div class="center quanyi bgf1 border-l">
                        <p class="h4">免费赠送十次试用机会</p>
                    </div>
                    <div class="border-lr center quanyi">
                        <img src="@/assets/img/vip/cuo.png" alt="" />
                    </div>
                    <div class="border-lr center quanyi bgf1">
                        <img src="@/assets/img/vip/cuo.png" alt="" />
                    </div>
                    <div class="border-lr center quanyi bd-r">
                        <img src="@/assets/img/vip/cuo.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
        <div class="box3 box">
            <div class="tit">
                <img src="@/assets/img/vip/left.png" alt="" />
                <p>会员常见问题</p>
                <img src="@/assets/img/vip/right.png" alt="" />
            </div>
            <div class="wenti box">
                <div class="item">
                    <div class="wen">
                        <img src="@/assets/img/vip/wen.png" alt="" />
                        <p>购买个人VIP后还可以成为企业VIP吗？</p>
                    </div>
                    <div class="da">
                        <div class="circle">
                            <div class="yuan"></div>
                        </div>
                        <p>
                            购买个人VIP的用户暂不能购买企业VIP或被邀请成为企业子账号成员。想升级企业VIP可等个人VIP到期后重新购买企业VIP。
                        </p>
                    </div>
                </div>
                <div class="item">
                    <div class="wen">
                        <img src="@/assets/img/vip/wen.png" alt="" />
                        <p>购买个人VIP，未到期续费，套餐时间怎么计算？</p>
                    </div>
                    <div class="da">
                        <div class="circle">
                            <div class="yuan"></div>
                        </div>
                        <p>
                            购买个人VIP后，在未到期的套餐时间内又进行再次购买套餐，新的套餐时间在上一个套餐到期时间后延续计算。
                        </p>
                    </div>
                </div>
                <a target="_blank" href="http://p.qiao.baidu.com/cps/chat?siteId=15881909&userId=31219776&siteToken=ab257d7b559bd01f6df8a87638c32e10"
                    class="zx">有疑问？立即咨询客服</a>
            </div>
        </div>
        <conversation></conversation>
        <Openvip ref="setcode" v-show="isShow" />
    </div>
</template>

<script>
import Conversation from "@/components/Conversation";
import Openvip from "@/components/Openvip";
export default {
    components: {
        Conversation,
        Openvip
    },
    data() {
        return {
            priceList: [],
            loading: true,
            code: "",
            data: {
                member: [],
                single: []
            },
            fd1: true, //个人会员放大
            fd2: false, //企业会员放大
            option1Show: 0, //个人会员选项1
            option4Show: 0, //个人会员选项2
            tq: "", //会员特权
            isShow: false,
            setparse: "", //个人开通总价
            selectindex: 0,
            month: 1, //开通年限
            endtime: "" //到期时间
        };
    },
    computed: {},
    watch: {},
    created() {
        this.getdata();
    },
    methods: {
        getdata() {
            this.$http.get("/app/order/singlePriceNew").then(res => {
                this.loading = false;
                this.data = res.data.data;
                for (var d in this.data) {
                    this.priceList.push({
                        month: d,
                        price: this.data[d]
                    });
                }
            });
        },
        getTime(time) {
            let yy = new Date(time).getFullYear();
            let mm = new Date(time).getMonth() + 1;
            let dd = new Date(time).getDate();
            return (
                yy + "-" + (mm < 10 ? "0" + mm : mm) + "-" + (dd < 10 ? "0" + dd : dd)
            );
        },
        select(i) {
            this.selectindex = i;
            this.option1Show = i;
            this.setparse = this.priceList[i].price;
            this.month = this.priceList[i].month;
        }, //开通价格选择
        closeVip() {
            //子组件也调用
            this.isShow = false;
        },
        openvip(state) {
            this.$http.get("/app/common/getNowTime").then(res => {
                if (res.data.code == 0) {
                    let json = {
                        payUse: 1, //订单类型（1 新开 2续费）
                        memberTypearry: this.priceList, //选中的会员价格数组
                        index: this.option1Show, //选中的索引值
                        end: this.getTime(res.data.data), //到期时间
                    };
                    this.$refs.setcode.getSrcList(json);
                    this.isShow = true;
                }
            });
        }
    },

    mounted() { }
};
</script>

<style lang="less" scoped>
.vipbody {
  .banner {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .box {
    width: 1200px;
    margin: 0 auto;
  }

  .flex {
    display: flex;
  }

  .tit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 610px;
    margin: 0 auto 60px;

    p {
      font-size: 32px;
      font-weight: 600;
      color: #243144;
    }
  }

  .box1 {
    padding: 60px 0;

    .item {
      margin: 0 auto;
      width: 580px;
      height: 450px;
      background-color: #ffffff;
      box-shadow: 0px 4px 16px 0px rgba(203, 203, 203, 0.4);
      border-radius: 20px;
      overflow: hidden;
      transform: scale(0.9);
      transition: all 1s;

      .item-t {
        width: 100%;
        height: 150px;

        .txt {
          padding: 44px 0 0 185px;

          .h2 {
            font-size: 30px;
            letter-spacing: 2px;
            color: #ffffff;
            font-weight: 600;
            padding-bottom: 10px;
          }

          .h3 {
            font-size: 18px;
            color: #ffffff;
            opacity: 0.9;
            float: left;
            padding-right: 12px;
          }
        }
      }

      .item-t1 {
        background: url("../../assets/img/vip/person.jpg") no-repeat center
          center;
        background-size: cover;
      }

      .item-t2 {
        background: url("../../assets/img/vip/company.jpg") no-repeat center
          center;
        background-size: cover;
      }

      .item-b {
        width: 100%;
        height: 300px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .select {
          width: 520px;
          justify-content: space-between;

          .option {
            width: 160px;
            height: 100px;
            box-shadow: 0px 2px 8px 0px #eeeeee;
            border-radius: 6px;
            background: url("../../assets/img/vip/graybg.jpg") no-repeat center
              center;
            background-size: cover;
            transition: all 0.5s;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .h2 {
              font-size: 16px;
              color: #333333;

              span {
                font-size: 24px;
                color: #ffb32f;
                font-weight: 600;
              }
            }

            .h3 {
              font-size: 12px;
              color: #666666;
              padding-top: 8px;

              span {
                color: #ffb32f;
              }
            }

            .span-b {
              span {
                color: #3176fc;
              }
            }
          }

          .xz {
            background: url("../../assets/img/vip/yellowbg.jpg") no-repeat
              center center;
            background-size: cover;
          }

          .xzl {
            background: url("../../assets/img/vip/bluebg.jpg") no-repeat center
              center;
            background-size: cover;
          }
        }

        .kt {
          width: 220px;
          height: 54px;
          background-image: linear-gradient(0deg, #ff9148 0%, #ffaf5a 100%);
          border-radius: 4px;
          font-size: 18px;
          font-weight: 600;
          letter-spacing: 1px;
          color: #ffffff;
          text-align: center;
          line-height: 54px;
          margin-top: 48px;
        }

        .kt1 {
          margin-top: 0;
          width: 202px;
          height: 48px;
          background-image: linear-gradient(0deg, #0066e5 0%, #3779ff 100%);
          border-radius: 4px;
          line-height: 48px;
          font-size: 16px;
        }

        .rs {
          margin: 20px auto;
          display: flex;
          justify-content: center;
          align-items: center;

          .jishu {
            width: 200px;
            display: flex;
            justify-content: flex-start;
            border: solid 1px #eeeeee;

            > div {
              width: 44px;
              height: 44px;
              background-color: #f5f5f5;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 22px;
              color: #999999;
              cursor: pointer;
            }

            input {
              display: block;
              width: 112px;
              height: 44px;
              border-left: solid 1px #eeeeee;
              border-right: solid 1px #eeeeee;
              font-size: 16px;
              font-weight: 600;
              line-height: 44px;
              text-align: center;
            }

            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
              -webkit-appearance: none;
            }

            input[type="number"] {
              -moz-appearance: textfield;
            }
          }
        }
      }
    }

    .fd {
      transform: scale(1);
      transition: all 1s;
    }
  }

  .box2 {
    width: 100%;
    background-color: #f2f7ff;
    padding: 80px 0 100px;

    .form {
      width: 900px;
      height: 570px;
      border-radius: 10px;
      border: solid 1px #cccccc;
      margin: 0 auto;

      .item {
        width: 300px;
        transform: all 1s;

        .border-l {
          border-left: 1px solid #eeeeee;
        }

        .border-lr {
          border-left: 1px solid #eeeeee;
          border-right: 1px solid #eeeeee;
        }

        .center {
          widows: 298px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .item-t {
          width: 100%;
          height: 134px;
          border-radius: 10px 0px 0px 0px;
          overflow: hidden;
          background: url("../../assets/img/vip/heng.png") #ffffff no-repeat
            center center;
          background-size: 64px 6px;

          p {
            font-size: 22px;
            color: #333333;
            font-weight: 600;
            margin-top: -20px;
          }
        }

        .top-c {
          width: 300px;
          height: 134px;
          flex-direction: column;
          border-left: 1px solid #eeeeee;
          border-right: 1px solid #eeeeee;
          background: #ffffff;

          .vip {
            display: flex;
            justify-content: center;
            align-items: center;

            p {
              font-size: 22px;
              color: #333333;

              font-weight: 600;
              padding-left: 10px;
            }
          }

          .ktvip {
            display: none;
            width: 120px;
            height: 36px;
            margin: 16px auto 0;
            background-color: #ffffff;
            border-radius: 18px;
            font-size: 16px;
            font-weight: 600;
            color: #f6a753;
            line-height: 36px;
            text-align: center;
          }
        }

        .quanyi {
          width: 300px;
          height: 108px;
          background: #fff;

          .txt {
            padding: 34px 0 0 30px;

            .h2 {
              display: flex;
              justify-content: flex-start;
              align-items: center;

              p {
                padding-left: 10px;
                font-size: 18px;

                color: #333333;
                font-weight: 600;
              }
            }

            .h3 {
              font-size: 14px;
              color: #999999;
              padding-top: 8px;
            }
          }

          .h4 {
            font-size: 14px;
            color: #333333;
          }
        }

        .bgf1 {
          background-color: #f1f4f6;
          border-top: solid 1px #eeeeee;
          border-bottom: solid 1px #eeeeee;
        }

        .quany4 {
          border-radius: 0px 0px 0px 10px;
          overflow: hidden;
        }
      }

      .item4 {
        .center {
          width: 298px;
        }

        .item-top {
          width: 299px;
          height: 134px;
          border-radius: 0px 10px 0px 0px;
          overflow: hidden;
          background: #fff;

          p {
            font-size: 22px;
            color: #333333;
            font-weight: 600;
            padding-left: 10px;
          }
        }

        .bd-r {
          border-radius: 0 0 10px 0;
          overflow: hidden;
        }
      }

      .fd1 {
        z-index: 6;

        .top-c {
          width: 302px;
          margin-top: -16px;
          margin-left: -1px;
          height: 150px;
          border-radius: 10px 10px 0px 0px;
          overflow: hidden;
          background-image: linear-gradient(0deg, #ff9148 0%, #ffaf5a 100%);
          border-left: 1px solid #eeeeee;
          border-right: 1px solid #eeeeee;

          .vip {
            p {
              color: #fff;
            }
          }

          .ktvip1 {
            display: block;
          }
        }

        .border-lr {
          border-left: solid 1px #f6a652;
          border-right: solid 1px #f6a652;
        }

        .bgf1 {
          border-top: solid 1px #f6a652;
          border-bottom: solid 1px #f6a652;
        }

        .border-b {
          border-radius: 0px 0px 10px 10px;
          height: 130px;
          border-bottom: solid 1px #f6a652;
          overflow: hidden;
        }
      }

      .fd2 {
        z-index: 6;

        .top-c2 {
          width: 302px;
          margin-top: -16px;
          margin-left: -1px;
          height: 150px;
          border-radius: 10px 10px 0px 0px;
          overflow: hidden;
          background-image: linear-gradient(0deg, #0066e5 0%, #3779ff 100%);

          .vip {
            p {
              color: #fff;
            }
          }

          .ktvip2 {
            display: block;
            color: #0267e6;
          }
        }

        .border-lr {
          border-left: solid 1px #3076fc;
          border-right: solid 1px #3076fc;
        }

        .bgf1 {
          border-top: solid 1px #3076fc;
          border-bottom: solid 1px #3076fc;
        }

        .border-b {
          border-radius: 0px 0px 10px 10px;
          height: 130px;
          border-bottom: solid 1px #3076fc;
          overflow: hidden;
        }
      }
    }
  }

  .box3 {
    padding: 110px 0 80px;

    .wenti {
      padding: 60px 0 38px;
      background-color: #ffffff;
      box-shadow: 0px 0px 20px 0px #eeeeee;
      border-radius: 10px;

      .item {
        width: 94%;
        margin: 0 auto 40px;

        .wen {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-bottom: 10px;

          p {
            font-size: 16px;
            color: #333333;
            font-weight: 600;
            padding-left: 10px;
          }
        }

        .da {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;

          .circle {
            width: 20px;
            height: 20px;
            display: flex;
            justify-content: center;
            align-items: center;

            .yuan {
              width: 6px;
              height: 6px;
              background-color: #f6a652;
              border-radius: 50%;
            }
          }

          p {
            font-size: 14px;
            color: #999999;
            line-height: 21px;
            width: 1092px;
          }
        }
      }

      .zx {
        display: block;
        width: 261px;
        height: 51px;
        background-color: #ffffff;
        border-radius: 2px;
        border: solid 1px #3176fc;
        text-align: center;
        line-height: 51px;
        font-size: 16px;
        color: #3176fc;
        margin: 20px auto;
      }
    }
  }
}
</style>
